import React from "react";
import { Typography, Box } from "@mui/material";
import { OSSIcon } from "@oss/components";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(theme => ({
  iconStyle: {
    height: 32,
    width: 32,
    color: theme.palette.catalogColors.purple.primary
  },
  blockListNameIcon: {
    fontSize: "2rem"
  }
}));

const OSSTableTitle = ({ iconName, title, typographyProps }) => {
  const classes = useStyles();

  return (
    <Box className={classes.titleContainer}>
      {iconName && (
        <OSSIcon name={iconName} className={classes.blockListNameIcon} />
      )}

      <Typography variant="h6" {...typographyProps} >
        {title}
      </Typography>
    </Box>
  );
};

export default OSSTableTitle;
